export type SyncButtonVendor = "JIRA" | "AZURE_DEVOPS" | null;

export interface SyncButtonState {
    show: boolean;
    vendor: SyncButtonVendor;
    tooltip: string;
}

// Mirrors the Feature Studio / Product Hub entry points: the sync button is
// shown for any open user story and SyncPanel resolves link/connection state
// after the click. The vendor flags only pick the icon — they must not gate
// visibility, because client-side project state can lag the backend (and the
// backend identifies the story ticket by variable, never by display title).
export function getSyncButtonState({
    userStoryId,
    hasJiraLink,
    hasAzureDevOpsLink
}: {
    userStoryId?: string;
    hasJiraLink?: boolean;
    hasAzureDevOpsLink?: boolean;
}): SyncButtonState {
    if (!userStoryId) {
        return { show: false, vendor: null, tooltip: "" };
    }
    if (hasJiraLink) {
        return { show: true, vendor: "JIRA", tooltip: "Sync with Jira" };
    }
    if (hasAzureDevOpsLink) {
        return { show: true, vendor: "AZURE_DEVOPS", tooltip: "Sync with Azure DevOps" };
    }
    return { show: true, vendor: null, tooltip: "Sync with Jira/DevOps" };
}
